/*
Certificate code:
Old: mhttp://youtrack.animatron.com/youtrack/issue/WEB-683
New: https://youtrack.animatron.com/youtrack/issue/WEB-2649
 */

class SecurePayment {
    imageSrc = 'https://wwwsslcom.a.cdnify.io/assets/ssl_seal_1-3dfcdf69a9e544495dbcf366a74ee5c4baca7e4f8018f7ddfa22f2de9bcf464d.png';

    getHref() {
        return `https://www.ssl.com/team/a3d-1b33o49/site_seals/${this.getId()}/site_report`;
    }

    openWindow(e: Event) {
        e.preventDefault();
        window.open(
            `https://www.ssl.com/team/a3d-1b33o49/site_seals/${this.getId()}/site_report`,
            'site_report',
            'height=500, width=400, top=100, left=100'
        );
    }

    private getId() {
        const {user, isProduction} = options;
        return user.zoneCode === 'kr'
            ? '4c157bc0-57032320' : isProduction
                ? '4f7e3f09-59fb2fa3'
                : '48ed36cd-59a99ce5';
    }
}

angular.module('animatronApp.settings').component('securePayment', {
    controller: SecurePayment,
    template: `<div class="subscription-secure-payment">
                    <a 
                        ng-click="$ctrl.openWindow($event)"
                        href="{{ $ctrl.getHref() }}">
                         <img 
                              ng-src="{{ $ctrl.imageSrc }}"
                              alt="Ssl seal 1"/>
                    </a>
                    <span>Secure credit card payment</span>
              </div>`
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/directives/securePaymentDirective.ts